import { useTranslation } from 'react-i18next';
import { supportedLanguages } from '../i18n';
import { Globe } from 'lucide-react';
import { useState } from 'react';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const currentLang = supportedLanguages.find((l) => l.code === i18n.language) || supportedLanguages[0];

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  const global = supportedLanguages.filter((l) => l.group === 'Global');
  const indian = supportedLanguages.filter((l) => l.group === 'India');

  const renderOption = (lang) => (
    <button
      key={lang.code}
      data-testid={`language-option-${lang.code}`}
      onClick={() => changeLanguage(lang.code)}
      className={`w-full text-left px-4 py-2 text-sm flex items-center gap-3 hover:bg-[#FFF9F0] transition-colors ${
        i18n.language === lang.code ? 'font-semibold' : ''
      }`}
      style={{ color: '#2D3748' }}
    >
      <span
        className="w-8 text-center font-bold rounded px-1.5 py-0.5 text-xs"
        style={{ background: '#FDE68A', color: '#2D3748' }}
      >
        {lang.label}
      </span>
      <span>{lang.name}</span>
    </button>
  );

  return (
    <div className="relative">
      <button
        data-testid="language-switcher-button"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-2 rounded-full text-sm font-semibold transition-colors hover:bg-[#FFF9F0]"
        style={{ color: '#4A5568' }}
      >
        <Globe size={18} />
        <span>{currentLang.label}</span>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)}></div>
          <div
            className="absolute right-0 mt-2 w-60 rounded-2xl border shadow-lg z-50 py-2 max-h-[28rem] overflow-y-auto custom-scrollbar"
            style={{ background: 'white', borderColor: '#F3E8E0', boxShadow: '0 8px 30px rgba(0,0,0,0.08)' }}
          >
            <div className="px-4 py-1 text-xs font-semibold uppercase tracking-wide" style={{ color: '#FF8E71' }}>
              Global
            </div>
            {global.map(renderOption)}
            <div className="h-px my-2" style={{ background: '#F3E8E0' }}></div>
            <div className="px-4 py-1 text-xs font-semibold uppercase tracking-wide" style={{ color: '#FF8E71' }}>
              🇮🇳 India
            </div>
            {indian.map(renderOption)}
          </div>
        </>
      )}
    </div>
  );
}
